import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';


import '../../../assets/styles/table.css';
import { Dialog } from '../modal/Modal';

const Table = ({ isFetching, tableColumns, tableData, isRowClickable, allData, isRowHover, origin }) => {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);
  const [rowIndex, setRowIndex] = useState(null)

  const toggleModal = (clickedRow) => {
    setOpenModal(!openModal)
    setRowIndex(clickedRow);
  }

  const history = useHistory();


  return (
    <table id='table-to-xls' className="table   mb-0">
      <thead className="bg-light">
        <tr>
          {
            tableColumns().map((column, index) => (
              <th style={{ whiteSpace: "nowrap" }} scope="col" className="border-0">
                {t(column)}
              </th>
            ))
          }
        </tr>
      </thead>
      <tbody className="w-100">
        {isFetching === false &&
          (tableData().length === 0 ? (
            <tr>
              <td colspan={tableColumns().length} className='text-center'>
                <h4>Não foram encontrados dados</h4>
              </td>
            </tr>
          ) : (
            tableData().map((row, index) => (
              <tr {...(isRowClickable && { onClick: () => origin === "service-home" ?  history.push(`/service/linear-list/${row[0]}`) : toggleModal(index) })} key={index} className={(row[4] === '---' && 'fill__tableRow')}>
                {
                  row.map((cellData, idx) => (
                    <td className='' style={{ maxWidth: "200px" }} data-label={tableColumns()[idx]}>
                      {cellData}
                    </td>
                  ))
                }
                {
                  openModal && <Dialog data={allData[rowIndex]} open={openModal} setOpen={toggleModal} />
                }
              </tr>
            ))
          ))}
      </tbody>
    </table>
  )
}

export default Table